<p-toast [baseZIndex]="1000" position="top-right"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-md-6">
          <lib-page-header page-title="CRÉDITO ADICIONAL"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            image-title="assets/img/money4.png">
          </lib-page-header>
        </div>
        <div class="col-md-6">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/creditos']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
        </div>
      </div>
      <hr class="mt-0 mb-4" />
      <div class="row mb-4">
        <div class="col-md-12">
          <div class="row">
            <div class="form-group col-md-4">
              <label for="tipo">Tipo de crédito<span class="text-danger">*</span></label>
              <input formControlName="tipo" readonly type="text" class="form-control-plaintext font-weight-bold"
                id="tipo">
            </div>
            <div class="form-group col-md-8">
              <label for="ocorrencia">Ocorrência<span class="text-danger">*</span></label>
              <input formControlName="ocorrencia" readonly type="text" class="form-control-plaintext font-weight-bold"
                id="ocorrencia">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-2">
              <label for="data_credito">Data</label>
              <input value="{{entidadeForm.get('data_credito').value | date:'dd/MM/yyyy':'GMT'}}" type="text"
                class="form-control-plaintext" id="data_credito">
            </div>
            <div class="form-group col-md-2">
              <label for="data_publica">Publicação</label>
              <input value="{{entidadeForm.get('data_publicacao').value | date:'dd/MM/yyyy':'GMT'}}" type="text"
                class="form-control-plaintext" id="data_publica">
            </div>
            <div class="form-group col-md-4">
              <label for="dec">Decreto N˚</label>
              <input formControlName="decreto" readonly type="text" class="form-control-plaintext" id="dec">
            </div>
            <div class="form-group col-md-4">
              <label for="lei">Lei N˚</label>
              <input formControlName="lei" readonly type="text" class="form-control-plaintext" id="lei">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-12">
              <label for="justificativa">Justificativa<span class="text-danger">*</span></label>
              <textarea readonly formControlName="justificativa" class="form-control-plaintext" id="justificativa"
                rows="4"></textarea>
            </div>
          </div>

        </div>
      </div>

      <img src="assets/img/global/total_plan_cost.png" alt="img" height="22" width="22"> <span
        class="text-black-50 font-weight-light"> Créditos suplementares </span>
      <table class="table table-eddy" *ngIf="listaItens && listaItens.length > 0">
        <thead>
          <tr>
            <th scope="col">Ficha de despesa orçamentária</th>
            <th scope="col" class="text-right">Valor</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listaItens">
            <td style="width: 60%">{{item.ficha.numero}} {{item.ficha.despesa.nome}}</td>
            <td style="width: 300px" class="text-right">
              {{item.valor_credito | number:'1.2-2'}}
              <span *ngIf="!item.editavel && item.valor_credito > 0"
                style="border-radius: 50%; height: 10px; width: 10px;" class="badge badge-success">&nbsp;</span>
              <span *ngIf="!item.editavel && item.valor_credito < 0"
                style="border-radius: 50%; height: 10px; width: 10px;" class="badge badge-danger">&nbsp;</span>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
